import { withCompInfo } from '@wix/editor-elements-integrations'
import type { ResponsiveContainerProps } from '@wix/thunderbolt-becky-types'
import type { SingleTabDefinition } from '../Tabs/Tabs.types'

export const props = withCompInfo<ResponsiveContainerProps | { containerRootClassName: string }, SingleTabDefinition>()(
	// @ts-ignore
	['responsiveContainerProps', 'containerRootClassName'],
	// @ts-ignore
	({ responsiveContainerProps, containerRootClassName }) => {
		return {
			containerProps: responsiveContainerProps,
			containerRootClassName,
		}
	}
)
